import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ALIGN, ILandingSection, LogoContent } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { LogoPrimitive } from "../primitive"
import Dummy from "./Dummy"
import DataContentEditor from "../landing-edit/editors/data-content-editor"


/* Protopia Ecosystem component */
export interface ILogoProps {
    section: ILandingSection
    data: LogoContent 
}
const Logo = ({data, ...props}: ILogoProps): JSX.Element => { 
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [alignItems]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "center" : "flex-start")
    const [justify]       = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "center" : "flex-start")
    const [width]         = useState<string>(getCssDemention( data.width,  "inherit" ))
    const [height, ]      = useState<string>(getCssDemention( data.height, "inherit" )) 

    useEffect(() => {
        addCSSClass(
            `landing-logo-${props.section.id}`,
            `.landing-logo-${props.section.id} {
                display: flex;
                align-items: ${alignItems};
                justify-content: ${justify};
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom}; 
                z-index:1;
            } 
            `
        )           
        return () => {
            removeCSSClass(`landing-logo-${props.section.id}`)
        }
    },[ ])
    return !!data.src  || true
        ?
        <div 
            className={`landing-content-container landing-logo landing-logo-${props.section.id} ${ data.className || "" } `} 
            style={ data.style || {} }  
            data-type={data.type} 
            data-content-id={data.id}
        >
            <LogoPrimitive 
                primitive={ {
                    ...( data ),
                    width:  width,
                    height: height || 70
                } as any }
            />
            <DataContentEditor data={data} section={props.section} />
        </div>
        :
        <Dummy {...{ 
            data: {...data, className: `landing-logo-${props.section.id}`}, 
            ...props 
        }} /> 
}
export default Logo

 